module.exports = __webpack_public_path__ + "static/img/CAPRI-OAK.ed2eed7.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CAPRI-OAK.png
// module id = ZVZ8
// module chunks = 0